import countries from './countries'

export const first_name = {
  name: "Nome",
  rules: { required: true, alpha_num_spaces: true, min: 2 },
  type: 'input',
  value: '',
}

export const last_name = {
  name: "Cognome",
  rules: { required: true, alpha_num_spaces: true, min: 2 },
  type: 'input',
  value: '',
}

export const address = {
  name: "Indirizzo",
  rules: { required: true, min: 3 },
  type: 'input',
  value: '',
}

export const city = {
  name: "Città",
  rules: { required: true, alpha_spaces: true, min: 3 },
  type: 'input',
  value: '',
}

export const postal_code = {
  name: "CAP",
  rules: { required: true, numeric: true, min: 5, max: 6 },
  type: 'input',
  value: '',
}

export const province = {
  name: "Provincia",
  rules: { required: true, alpha: true, min: 2, max: 2 },
  type: 'input',
  value: '',
}

export const fiscal_code = {
  name: "Codice fiscale",
  rules: { required: true, alpha_num: true, length: 16 },
  type: 'input',
  value: '',
}

export const bill_to_pax_fiscal_code = {
  name: "Codice fiscale",
  rules: { required: true, alpha_num: true, length: 16 },
  type: 'input',
  value: '',
}

export const phone_prefix = {
  name: "Prefisso telefonico",
  rules: { required: true },
  type: 'select',
  value: '39', // default Italia
  options: countries.map(country => ({
    value: country.phone_code,
    text: country.phone_display,
  })),
}

export const phone = {
  name: "Telefono",
  rules: { required: true, numeric: true, min: 6 },
  type: 'input',
  value: '',
}

export const email = {
  name: "Email",
  rules: { required: true, email: true },
  type: 'input',
  value: '',
}

export const email_conf = {
  name: "Conferma email",
  rules: 'confirm_email:@email',//rules: 'required|email|confirm_email:@email',
  type: 'input',
  value: '',
}

// privacy = termini e condizioni, gdpr = privacy policy
export const privacy = {
  name: "Termini e condizioni",
  rules: { is: [true] },
  type: 'checkbox',
  value: false,
  text: 'Ho preso visione delle <a href="/termini-e-condizioni" target="_blank">condizioni d\'uso</a> e le accetto',
}

export const gdpr = {
  name: "Privacy policy",
  rules: { is: [true] },
  type: 'checkbox',
  value: false,
  text: 'Ho preso visione delle <a href="/privacy-policy" target="_blank">condizioni di trattamento dei dati</a> e le accetto',
}

export const disclaimer_checkout = {
  name: "Disclaimer checkout",
  rules: { is: [true] },
  type: 'checkbox',
  value: false,
}

export const terms_and_privacy = {
  name: "Condizioni d'uso e Privacy Policy",
  rules: { is: [true] },
  type: 'checkbox',
  value: false,
  text: 'Dichiaro di aver letto e accettato le <a href="/termini-e-condizioni" target="_blank" class="underline">Condizioni d\'uso</a> e la <a href="/privacy-policy" target="_blank" class="underline">Privacy Policy</a>, incluse le modalità di trattamento dei dati.',
}